(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  if (!customElements.get('nordeen-cart-suggestions')) {
    customElements.define('nordeen-cart-suggestions', class extends HTMLElement {
      async connectedCallback() {
        let viewed, cart;
        try {
          viewed = JSON.parse(localStorage.getItem('theme:recently-viewed-products') || '[]');
          cart = JSON.parse(this.dataset.cartProducts || '[]');
        } catch (_) { return; }
        if (!Array.isArray(viewed) || !Array.isArray(cart)) return;
        const seen = new Set(cart.map(String));
        const sources = [...new Set(viewed.map(String).filter(id => /^\d+$/.test(id)))].slice(0, 3);
        if (!sources.length) return;
        const root = this.dataset.root || '/';
        const results = await Promise.all(sources.map(async id => {
          try {
            const url = new URL(root.replace(/\/?$/, '/') + 'recommendations/products.json', location.origin);
            url.searchParams.set('product_id', id);
            url.searchParams.set('intent', 'related');
            url.searchParams.set('limit', '10');
            const response = await fetch(url, { credentials: 'same-origin' });
            if (!response.ok) return [];
            const data = await response.json();
            return Array.isArray(data.products) ? data.products : [];
          } catch (_) { return []; }
        }));
        if (!this.isConnected) return;
        const products = [];
        for (const group of results) for (const product of group) {
          const id = String(product.id);
          if (seen.has(id) || !product.available || !product.url) continue;
          seen.add(id);
          products.push(product);
          if (products.length >= 4) break;
        }
        if (!products.length) return;
        const items = document.createElement('div');
        items.className = 'nordeen-suggestions__items';
        for (const product of products.slice(0, 4)) {
          const link = document.createElement('a');
          let productUrl;
          try { productUrl = new URL(product.url, location.origin); } catch (_) { continue; }
          if (productUrl.origin !== location.origin) continue;
          link.href = productUrl.href;
          link.className = 'nordeen-suggestions__item';
          const img = document.createElement('img');
          img.className = 'nordeen-suggestions__image';
          img.alt = '';
          img.loading = 'lazy';
          if (product.featured_image) img.src = product.featured_image;
          const text = document.createElement('span');
          const title = document.createElement('span');
          title.className = 'nordeen-suggestions__title';
          title.textContent = product.title;
          text.append(title);
          if (typeof product.price === 'number') {
            const price = document.createElement('span');
            price.className = 'nordeen-suggestions__price';
            try { price.textContent = (product.price_varies ? 'Vanaf ' : '') + new Intl.NumberFormat(document.documentElement.lang || 'nl-NL', {style:'currency', currency: window.Shopify?.currency?.active || 'EUR'}).format(product.price / 100); } catch (_) {}
            text.append(price);
          }
          link.append(img, text);
          items.append(link);
        }
        if (!items.children.length) return;
        const container = document.createElement('div');
        container.className = 'nordeen-suggestions';
        const heading = document.createElement('p');
        heading.className = 'h7';
        heading.textContent = 'Misschien vind je dit ook leuk';
        container.append(heading, items);
        this.replaceChildren(container);
        this.hidden = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
